import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "typeahead typeahead-wrapper" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTypeahead',
  setup(__props) {

const basicTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/basicTypeahead.vue"))
const prefetchTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/prefetchTypeahead.vue"))
const bloodhoundTyeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/bloodhoundTyeahead.vue"))
const remoteTypeahead = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/remoteTypeahead.vue"))
const customTemplates = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/customTemplates.vue"))
const multipleSections = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/multipleSections.vue"))
const scrollableMenu = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/scrollableMenu.vue"))
const rtlSupport = defineAsyncComponent(() => import("@/components/theme/forms/formwidgets/typeahead/rtlSupport.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Widgets",
      title: "Typeahead"
    }),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "alert txt-primary alert-light-primary alert-dismissible fade show",
        role: "alert"
      }, [
        _createElementVNode("i", { "data-feather": "alert-triangle" }),
        _createElementVNode("p", null, [
          _createTextVNode("This is the Typeahead page where "),
          _createElementVNode("strong", null, "jQuery "),
          _createTextVNode(" was utilised.")
        ]),
        _createElementVNode("button", {
          class: "btn-close",
          type: "button",
          "data-bs-dismiss": "alert",
          "aria-label": "Close"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(basicTypeahead)),
          _createVNode(_unref(prefetchTypeahead)),
          _createVNode(_unref(bloodhoundTyeahead)),
          _createVNode(_unref(remoteTypeahead)),
          _createVNode(_unref(customTemplates)),
          _createVNode(_unref(multipleSections)),
          _createVNode(_unref(scrollableMenu)),
          _createVNode(_unref(rtlSupport))
        ])
      ])
    ])
  ], 64))
}
}

})